import styled from 'styled-components';

export const UiHomeSchoolFormPage = styled.div`
	display: block;
`;
